<script>
import axios from 'axios'
import md5Encrypt from 'js-md5'
import CryptoJS from 'crypto-js'
import { uuid } from 'vue-uuid';
import serverurl from './UrlConst';

//定义全局信息
let _userInfo_ = { username: "null", authed: "failed" };
let _userInfoExt_ = {};
let _systemDictionary_ = {};
let _lastUrl_ = { url: "" };
let _userMenu_ = {};
let _userMenuForPermission_ = {};
let _userMenuForButton_ = {};
let _permissionTemplate_ = {};
let _pageSize_ = 10;
let _crypto_key_ = "hskj_123456_hskj";
let _win_w_h_ = {};
let _permission_organ_key_ = {};
let _userOrgan_ = {};

let _serverUrl_ = serverurl.serverUrl;
// let _serverUrl_ = {
//    baseURI:'http://localhost:28080',
//    orgBaseURI:'http://localhost:38080',
//   //baseURI:'http://47.110.133.115:28080',
//   postMerCheckLogin2:'/fr/postMerCheckLogin2',
//   postMerCheckLogin:'/fr/postMerCheckLogin',
//   postQueryValveCurrentDataList:'/fr/postQueryValveCurrentDataList',
//   postMerLoginSessionClear:'/fr/postMerLoginSessionClear',
//
//
// };

/**自定义工具集,必须是以const定义对外发布的方法名称**/
//返回格式：1是YYYY_MM_DD_hh_mm_ss_SSS，2是YYYY-MM-DD hh:mm:ss,3是YYYYMMDDhhmmssSSS,4是YYYY-MM-DD,5是hh:mm,6是YYYYMMDD_hhmmssSSS_

const getFormatDateTimeString = type => {
  //////////
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  var SSS = date.getMilliseconds();
  var dateStr = "";
  if (type == "1") {
    dateStr = year + "_" + formatNum(month) + "_" + formatNum(day) + "_" + formatNum(hour) + "_" + formatNum(minute) + "_" + formatNum(second) + "_" + SSS;
  } else if (type == "2") {
    dateStr = year + "-" + formatNum(month) + "-" + formatNum(day) + " " + formatNum(hour) + ":" + formatNum(minute) + ":" + formatNum(second);
  } else if (type == "3") {
    dateStr = year + "" + formatNum(month) + "" + formatNum(day) + "" + formatNum(hour) + "" + formatNum(minute) + "" + formatNum(second) + "" + SSS;
  } else if (type == "4") {
    dateStr = year + "-" + formatNum(month) + "-" + formatNum(day);
  } else if (type == "5") {
    dateStr = formatNum(hour) + ":" + formatNum(minute);
  } else if (type == "6") {
    dateStr = year + "" + formatNum(month) + "" + formatNum(day) + "_" + formatNum(hour) + "" + formatNum(minute) + "" + formatNum(second) + "" + formatNum2(SSS, 3) + "_";
  }
  return dateStr;
  ///////////////
}
//补位，不足两位的前面补0
const formatNum = num => {
  if (num.toString().length < 2) {
    return "0" + num;
  } else {
    return num;
  }
}
const formatNum2 = (num, len) => {
  if (num.toString().length < len) {

    while (num.toString().length < len) {
      num = "0" + num;

    }

    return num;
  } else {
    return num;
  }
}


//返回一个Promise(发送post请求)


/***
 *  // headers: {"Content-Type": "application/json"},
    //headers: {"Content-Type": "application/x-www-form-urlencoded"},
     data: {
          username: 'sa',
          password:'123456'
        }
     params: {
          username: 'sa',
          password:'123456'
     }
 * */
const postHttpClient = (_url_, _baseURL_, _headers_, _data_) => {
  //export function httpClient1   (_url_, _baseURL_,_method_,_headers_,_data_)  {
  return new Promise((resolve, reject) => {

    if (_headers_ == undefined || _headers_ == '') {
      _headers_ = { "Content-Type": "application/json" };
      //headers: {"Content-Type": "application/x-www-form-urlencoded"},
    }

    // console.info("data:"+JSON.stringify(_data_));
    axios(
      {
        url: _url_,
        baseURL: _baseURL_,
        data: _data_,
        method: 'post',
        headers: _headers_,
        timeout: 10000,
        withCredentials: true,//双刃剑
      }
    ).then(response => {
      resolve(response);
    }, err => {
      console.info("commonsPost_err:" + JSON.stringify(err));
      reject(err);
    })
      .catch((error) => {
        console.info("commonsPost_error:" + JSON.stringify(error));
        reject(error)
      })
  })
}
// 过滤器 1
import Vue from 'vue'
Vue.filter('format', function (value) {
  return value.substring(value.length - 9, value.length);
});
/**
 * 下载文件
 * */
const postHttpClient2 = (_url_, _baseURL_, _headers_, _data_) => {
  //export function httpClient1   (_url_, _baseURL_,_method_,_headers_,_data_)  {
  return new Promise((resolve, reject) => {

    if (_headers_ == undefined || _headers_ == '') {
      _headers_ = { "Content-Type": "application/json" };
      //headers: {"Content-Type": "application/x-www-form-urlencoded"},
    }

    // console.info("data:"+JSON.stringify(_data_));
    axios(
      {
        url: _url_,
        baseURL: _baseURL_,
        data: _data_,
        method: 'post',
        responseType: 'blob',
        headers: _headers_,
        timeout: 6000,
        withCredentials: true,//双刃剑
      }
    ).then(response => {
      //////////////
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
      let _filenames_ = response.headers['content-disposition'];
      let filename = _filenames_.match(/=(.*)$/)[1];
      if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
        navigator.msSaveBlob(blob, filename);
      } else {
        //console.log(blob)
        const url = window.URL.createObjectURL(blob)
        //console.log(url)
        const aLink = document.createElement('a')
        aLink.style.display = 'none'
        aLink.href = url
        aLink.setAttribute('download', filename);
        document.body.appendChild(aLink)
        aLink.click()
        document.body.removeChild(aLink)
        window.URL.revokeObjectURL(url)
      }



      ////////////
      resolve(response);
    }, err => {
      console.info("commonsPost_err:" + JSON.stringify(err));
      reject(err);
    })
      .catch((error) => {
        console.info("commonsPost_error:" + JSON.stringify(error));
        reject(error)
      })
  })
}
const getHttpClient = (_url_, _baseURL_, _headers_, _data_) => {
  return new Promise((resolve, reject) => {

    if (_headers_ == undefined || _headers_ == '') {
      _headers_ = { "Content-Type": "application/json" };
      //headers: {"Content-Type": "application/x-www-form-urlencoded"},
    }


    axios(
      {
        url: _url_,
        baseURL: _baseURL_,
        params: _data_,
        method: 'get',
        headers: _headers_,
        timeout: 6000,
        withCredentials: true,//双刃剑
      }
    ).then(response => {
      resolve(response);
    }, err => {
      console.info("commonsPost_err:" + JSON.stringify(err));
      reject(err);
    })
      .catch((error) => {
        console.info("commonsPost_error:" + JSON.stringify(error));
        reject(error)
      })
  })
}

const getFileBase64 = (e) => {
  return new Promise((resolve, reject) => {

    var reader = new FileReader();
    reader.onload = e => {
      let data;
      if (typeof e.target.result === 'object') {
        // 把Array Buffer转化为blob 如果是base64不需要
        data = window.URL.createObjectURL(new Blob([e.target.result]));
        resolve(data);
      } else {
        data = e.target.result;
        resolve(data);
      }

    };
    // 转化为base64
    reader.readAsDataURL(file);


  })
}

/**
 * 必须是数字
 * */
function isnumber (value) {
  let patrn = /^\d+$/;
  if (patrn.test(value)) {
    return true;
  } else {
    return false;
  }
}
/**
 * 必须是浮点数字
 * */
function isfloat (value) {
  let patrn = /^(-?\d+)(\.\d+)?$/;
  if (patrn.test(value)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 必须是数字或浮点数
 * */
function isnumberandfloat (value) {
  if (isnumber(value) == true || isfloat(value) == true) {
    return true;
  } else {
    return false;
  }
}
/**
 * md5加密
 * **/
function md5 (value) {
  return md5Encrypt(value);
}

/*
keyStr 的长度要不小于14位
* 对密码进行加密，传输给后台进行验证
* @param {String}   word  需要加密的密码
* @param {String}   keyStr  对密码加密的秘钥
* @return {String}   加密的密文
* */
function encrypt (word, keyStr) { // 加密
  keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG12';
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
//要求keyStr长度等于16位
function encryptCBC (word, keyStr) { // 加密
  keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG12';
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: key,
    // mode: CryptoJS.mode.ECB,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
/*
keyStr 的长度要不小于14位
* 对加密之后的密文在页面上进行解密，以便用户进行修改
* @param {String}   word  需要加密的密码
* @param {String}   keyStr  对密码加密的秘钥
* @return {String}   解密的明文
* */
function decrypt (word, keyStr) { // 解密
  keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG12';
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
//要求keyStr长度等于16位
function decryptCBC (word, keyStr) { // 解密
  keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG12';
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: key,
    // mode: CryptoJS.mode.ECB,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
function strMapToObj (strMap) {
  let obj = Object.create(null);
  for (let [k, v] of strMap) {
    obj[k] = v;
  }
  return obj;
}

/**
 *map转换为json
 */
function mapToJson (map) {
  return JSON.stringify(strMapToObj(map));
}

function objToStrMap (obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
/**
 *json转换为map
 */
function jsonToMap (jsonStr) {
  return objToStrMap(JSON.parse(jsonStr));
}
//生成UUID
function genuuid () {
  return uuid.v4().replaceAll("-", "");
}

function random (min = 0, max = 255) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function generateRandomSerial (len) {
  let sRe = "";
  let mm = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  for (var i = 0; i < len; i++) {
    sRe = sRe + mm[random(0, mm.length - 1)];
  }
  return sRe;
}
//生成雪花uuid
function genLogicNo (code) {

  let y = getFormatDateTimeString("6");
  let default_tansid_type = "10";
  let inter_trans_id_length = 32;

  let sb = "";
  sb = sb.concat(code + "_" + y).concat(default_tansid_type);
  let tmp = generateRandomSerial(inter_trans_id_length - sb.length);
  sb = sb.concat(tmp);
  return sb;

}

/***
 * 增加同级或子级
 * @param curId 当前选中的节点ID
 * @param sourceData tableData数据对象
 * @param targetData 新增加或修改的对象内容
 * @param layer 1是同级，2是子级
 * @param flag 1是新增，2是修改，3是删除。
 *
 */

function checkPermissionId (curId, sourceData, targetData, layer, flag) {
  console.info("进入checkPermissionId:" + sourceData)
  console.info("查询选中ID:" + curId);
  var result = false;
  for (var i1 = 0; i1 < sourceData.length; i1++) {
    console.info("当前id:" + sourceData[i1].id);
    if (flag === '1') {
      if (sourceData[i1].id === curId) {
        if (layer === '1') {//同级
          sourceData.push(targetData);
          console.info("add find ok");
          result = true;
          break;
        } else if (layer === '2') {
          if (sourceData[i1].hasOwnProperty("detail")) {
            console.info("add 存在detail,直接追加:" + JSON.stringify(sourceData[i1]))
            let detail = sourceData[i1].detail;

            detail.push(targetData);
            sourceData[i1].detail = detail;
            result = true;
            break;
          } else {
            let detail = [];

            detail.push(targetData);
            sourceData[i1].detail = detail;
            console.info("add 不存在detail,新创建detail:" + JSON.stringify(sourceData[i1].detail));
            result = true;
            break;
          }
        }
        //break;
      } else {
        if (sourceData[i1].hasOwnProperty("detail")) {
          console.info("add not find 递归查询detail")
          result = this.checkPermissionId(curId, sourceData[i1].detail, targetData, layer, flag);
          if (result === true) {
            break;
          }
        } else {
          console.info("add not find");
          result = false;
        }
      }

    }//end if(flag==='1'){
    else if (flag === '2') {
      if (sourceData[i1].id === curId) {
        //sourceData[i1].caption = targetData.caption;
        for (let k of Object.keys(targetData)) {
          sourceData[i1][k] = targetData[k];
          console.info("修改内容：【" + k + "】" + sourceData[i1][k]);
        }

        console.info("modify find ok");
        result = true;
        break;
      } else {
        if (sourceData[i1].hasOwnProperty("detail")) {
          console.info("modify not find 递归查询detail")
          result = this.checkPermissionId(curId, sourceData[i1].detail, targetData, layer, flag);
          if (result === true) {
            break;
          }
        } else {
          console.info("modify not find");
          result = false;
        }
      }
    } else if (flag === '3') {
      if (sourceData[i1].id === curId) {
        sourceData.splice(i1, 1);
        console.info("del find ok");
        result = true;
        break;
      } else {
        if (sourceData[i1].hasOwnProperty("detail")) {
          console.info("del not find 递归查询detail")
          result = this.checkPermissionId(curId, sourceData[i1].detail, targetData, layer, flag);
          if (result === true) {
            break;
          }
        } else {
          console.info("del not find");
          result = false;
        }
      }
    }


  }
  return result;

}
/**
 * 检测按钮权限
 * let btnkey = this.customGlobal.permissionKeyOrganKey.btnkey;
 *  <el-button  v-show="checkBtnPermission('btn_uuid_1',btnkey)" style="" type="primary" @click="deleteData">删除</el-button>
 * @param id 按钮id
 * @param btnPermission 按钮权限对象，如：{'btn_uuid_1':false,'btn_uuid_2':false,'btn_uuid_3':false}
 * */
function checkBtnPermission (id, btnPermission) {
  // let bRe = false;
  let bRe = true;
  for (let k of Object.keys(btnPermission)) {
    if (id === k && btnPermission[k] === false) {
      bRe = false;
      break;
    }
  }
  // for(var i1=0;i1<this.btnPermission.length;i1++){
  //   if(id===this.btnPermission[i1]){
  //     bRe = true;
  //     break;
  //   }
  // }
  return bRe;
}
function dateToWeek (value) {
  let date = value;// //'2017-12-30'
  let datelist = ['周日', '周一', '周二', '周三', '周四', '周五', '周六',];
  return datelist[new Date(date).getDay()];
}
function refreshGlobalDetail (_global_) {
  var userInfo = window.sessionStorage.getItem("userInfo");

  var serverUrl = window.sessionStorage.getItem("serverUrl");
  var userMenu = window.sessionStorage.getItem("userMenu");
  var userInfoExt = window.sessionStorage.getItem("userInfoExt");
  var userMenuForPermission = window.sessionStorage.getItem("userMenuForPermission");
  var userMenuForButton = window.sessionStorage.getItem("userMenuForButton");
  var systemDictionary = window.sessionStorage.getItem("systemDictionary");
  var permissionKeyOrganKey = window.sessionStorage.getItem("permissionKeyOrganKey");
  var userOrgan = window.sessionStorage.getItem("userOrgan");


  if (userInfo) {
    _global_.userInfo = JSON.parse(decrypt(userInfo, _crypto_key_));
    _global_.userInfoExt = JSON.parse(decrypt(userInfoExt, _crypto_key_));
    // _global_.serverUrl = JSON.parse(serverUrl);
    _global_.userMenu = JSON.parse(decrypt(userMenu, _crypto_key_));

    _global_.userMenuForPermission = JSON.parse(decrypt(userMenuForPermission, _crypto_key_));
    _global_.userMenuForButton = JSON.parse(decrypt(userMenuForButton, _crypto_key_));
    _global_.systemDictionary = JSON.parse(decrypt(systemDictionary, _crypto_key_));
    _global_.permissionKeyOrganKey = JSON.parse(decrypt(permissionKeyOrganKey, _crypto_key_));
    _global_.userOrgan = JSON.parse(decrypt(userOrgan, _crypto_key_));
    //
  }
}
function refreshDtRouter (userMenuForPermission) {
  ////////
  let _children_ = new Array();
  let _parentRoute_ = {};

  let menus = JSON.parse(decrypt(userMenuForPermission, _crypto_key_));
  for (let i1 = 0; i1 < menus.length; i1++) {
    if (!menus[i1].detail) {
      continue
    }
    //console.info("url:"+menus[i1].detail);
    for (let i2 = 0; i2 < menus[i1].detail.length; i2++) {
      // console.info("url:"+menus[i1].detail[i2].url);
      _children_.push(
        {
          name: menus[i1].detail[i2].url,
          path: menus[i1].detail[i2].url,
          // component : IndexRight1
          //component: resolve => require(['@/components' + menus[i1].detail[i2].vue], resolve)
          //注意全路径
          component: () => import('@/components' + menus[i1].detail[i2].vue)
        }
      );
    }
  }
  //增加额外业务路由
  _children_.push(
    {
      name: 'org_query1',
      path: '/org_query1',
      component: () => import('@/components/index/right/Example4.vue')//将组件用require引进来
    });
  _children_.push(
    {
      name: 'org_query',
      path: '/org_query',
      component: () => import('@/components/views/orgInfoManager/OrgInfoCenter.vue')//将组件用require引进来
    });
  _children_.push(
    {
      name: 'org_query_bank',
      path: '/org_query_bank',
      component: () => import('@/components/views/bankPlatform/orgInfo/OrgInfoCenterBank.vue')//将组件用require引进来
    });
  // _children_.push(
  //   {
  //     name:'org_query_bank2',
  //     path: '/org_query_bank2',
  //     component: () => import('@/components/views/bankPlatform/orgInfo/OrgInfoCenterBank2.vue' )//将组件用require引进来
  //   });
  _children_.push(
    {
      name: 'device_query',
      path: '/device_query',
      component: () => import('@/components/views/deviceManager/DeviceInfoCenter.vue')//将组件用require引进来
    });

  //
  _parentRoute_ =
  {
    name: "index",
    path: "/index",
    component: resolve => require(['@/pages/Index.vue'], resolve),
    // component : () => import('@/pages/Index.vue' ),
    children: _children_
  };
  let dtRouter = [_parentRoute_];
  return dtRouter;
}
/**
 * formatDate(new Date("2021-08-03 10:04:20"), 'yyyy-MM-dd hh:mm:ss');
 * */
function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }; // 月份 // 日 // 小时 // 分 // 秒 // 季度 // 毫秒
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      );
    }
  }
  return fmt;
}
/**
 * @param date 2021-11-15 18:55:49
 * @return 返回13位时间戳
 * */
function getDateTimeToTimestamp (date) {
  var date = new Date(date);
  var time1 = date.getTime();
  return time1;
}
/**
 * @param timestamp 1398250549123
 * @return 返回YYYY-MM-DD hh:mm:ss
 * 84600 * 1000 是一天
 * */
function getTimestampToDateTime (timestamp) {
  var date = new Date(timestamp);

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  var SSS = date.getMilliseconds();
  var dateStr = year + "-" + formatNum(month) + "-" + formatNum(day) + " " + formatNum(hour) + ":" + formatNum(minute) + ":" + formatNum(second);
  return dateStr;
}

function jsonSort (_detail_) {
  //排最外层
  _detail_ = sortKey(_detail_, "sortId");
  //排子层
  for (let i1 = 0; i1 < _detail_.length; i1++) {
    if (_detail_[i1].hasOwnProperty("detail")) {
      _detail_[i1].detail = jsonSort(_detail_[i1].detail);
      //return _detail_[i1];
    } else {
      _detail_ = sortKey(_detail_, "sortId");
      //return _detail_[i1];

    }
  }
  return _detail_;


}
function sortKey (array, key) {
  return array.sort(function (a, b) {
    if (!a.hasOwnProperty(key)) {
      a[key] = 0;
    }
    if (!b.hasOwnProperty(key)) {
      b[key] = 0;
    }
    var x = parseInt(a[key]);
    var y = parseInt(b[key]);
    return ((x < y) ? -1 : (x > y) ? 1 : 0)
    // return ((x<y)?1:(x>y)?-1:0)


  })
}

export default {
  name: "Global",
  userInfo: _userInfo_,
  userInfoExt: _userInfoExt_,
  userMenu: _userMenu_,
  permissionTemplate: _permissionTemplate_,
  userMenuForPermission: _userMenuForPermission_,
  userMenuForButton: _userMenuForButton_,
  lastUrl: _lastUrl_,
  serverUrl: _serverUrl_,
  pageSize: _pageSize_,
  cryptoKey: _crypto_key_,
  win_w_h: _win_w_h_,
  systemDictionary: _systemDictionary_,
  permissionKeyOrganKey: _permission_organ_key_,
  userOrgan: _userOrgan_,
  isnumber: isnumber,
  isfloat: isfloat,
  isnumberandfloat: isnumberandfloat,

  getFormatDateTimeString: getFormatDateTimeString,
  postHttpClient: postHttpClient,
  postHttpClient2: postHttpClient2,
  getHttpClient: getHttpClient,
  md5: md5,
  mapToJson: mapToJson,
  jsonToMap: jsonToMap,
  encrypt: encrypt,
  encryptCBC: encryptCBC,
  decrypt: decrypt,
  decryptCBC: decryptCBC,
  genuuid: genuuid,
  checkPermissionId: checkPermissionId,
  genLogicNo: genLogicNo,
  checkBtnPermission: checkBtnPermission,
  refreshGlobalDetail: refreshGlobalDetail,
  refreshDtRouter: refreshDtRouter,
  dateToWeek: dateToWeek,
  formatDate: formatDate,
  getTimestampToDateTime: getTimestampToDateTime,
  getDateTimeToTimestamp: getDateTimeToTimestamp,
  getFileBase64: getFileBase64,
  jsonSort: jsonSort,


}
</script>




// WEBPACK FOOTER //
// src/utils/Global.vue